import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { dataToDocument } from './dataToDocument'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useParams } from 'react-router-dom'
import { useAuth, useDocumentCategory } from '../'

const { env } = window

const useDocuments = () => {
  const { tenantUrlSlug, affiliationUrlSlug } = useParams()
  const { loggedIn, securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { progressStart, progressEnd } = useActions()
  const { category } = useDocumentCategory()

  const getDocuments = async (categoryId) => {
    const fetchFn = loggedIn ? securedFetch : fetch
    const url = encodeURI(
      `${
        loggedIn ? env.apiUrl : env.publicApiUrl
      }/categories/${categoryId}/documents`
    )
    const response = await fetchFn(url)
    await handleResponse(response)
    const data = await response.json()
    return data.map((item) =>
      dataToDocument(
        item,
        `${tenantUrlSlug}/${affiliationUrlSlug}/${category.urlSlug}`
      )
    )
  }

  const query = useQuery({
    queryKey: ['documents', category?.id],
    queryFn: () => getDocuments(category?.id),
    enabled: !!category
  })

  useEffect(() => {
    if (query.isLoading) {
      progressStart()
    } else if (query.isSuccess) {
      progressEnd()
    } else if (query.isError) {
      handleError(query.error, 'Error getting documents')
      progressEnd()
    }
  }, [
    query.isLoading,
    query.isSuccess,
    query.isError,
    query.error,
    progressStart,
    progressEnd,
    handleError
  ])

  return {
    documents: query.data
  }
}

export { useDocuments }
